import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const router = new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import('../components/Login.vue')
    },
    {
      path: '/results',
      name: 'results',
      component: () => import('../components/Results.vue')
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('../components/Dashboard.vue')
    },
    { path: '*', redirect: '/' }
  ]
})
